module.exports = __webpack_public_path__ + "img/nz.a8f100c.svg";